// extracted by mini-css-extract-plugin
module.exports = {"form":"ChangePassword__form--3p3","formActions":"ChangePassword__formActions--3Y6","submit":"ChangePassword__submit--2Ab"};